function getBooleanEnvValue(value, defaultValue = false) {
    if (typeof value === "boolean") {
        return value;
    }
    const normalizedValue = String(value ?? "").trim().toLowerCase();
    if (!normalizedValue) {
        return defaultValue;
    }
    return ["1", "true", "yes", "on"].includes(normalizedValue);
}

const defaultConfig= {
    appTokenKey:"sj_mall_admin_token", // 集运token key
    mallAppTokenKey:"mall_app_user_key", // 商城token key
    isTbPurchaseOrderMode:"isTbPurchaseOrderMode", // 是否是淘宝采购1688订单
    layoutCommonConfig:{  // 商城配置
        header:{ 
            url:"common-layout-header",
        },
        footer:{
            url:"common-layout-footer",   
        }
    },
    // layoutCommonConfig:{
    //     header:{
    //         url:"site-layout-header",
    //     },
    //     footer:{
    //         url:"site-layout-footer",   
    //     }
    // },
    devErpBuySite:false,// 开启erp采购调试
    isCmsSite:true, // 是否启用 CMS 站点 device 跳转
    disabledMallSsr:true, // 是否关闭电商相关 SSR
    proxyLinks:{
        collectionSite: "tmallsitehost:8080",
        frontServerSite: "tmall-front-nodejs-server:3000",
        mallSite: "jyshoprelink:8081",
        qiankunSite: "pc-qiankun-site:7788",
    }
} 
export default defaultConfig;
